// extracted by mini-css-extract-plugin
module.exports = {"participants":"_7c6b12d","participant":"_3263b54","srOnly":"_32469d7","americanFirstParticipant":"_11a1844"};